import classNames from 'classnames';

import { iconDefaults } from '.';
import { IconProps as Props } from '../types/hubInterfaces';

function ProfileIcon(props: Props) {
  const { width, height, className } = { ...iconDefaults, ...props };
  return (
    <svg width={`${width}`} height={`${height}`} viewBox="0 0 24 24" fill="none" className={classNames(className)}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.8461 20.0001C18.8461 20.5521 18.404 21.0001 17.8571 21.0001C17.3102 21.0001 16.8681 20.5521 16.8681 20.0001C16.8681 17.2431 14.6497 15.0001 11.923 15.0001C9.19635 15.0001 6.97801 17.2431 6.97801 20.0001C6.97801 20.5521 6.53593 21.0001 5.98901 21.0001C5.44209 21.0001 5 20.5521 5 20.0001C5 16.1401 8.10647 13.0001 11.923 13.0001C15.7396 13.0001 18.8461 16.1401 18.8461 20.0001ZM11.9233 5C13.0142 5 13.9013 5.897 13.9013 6.99999C13.9013 8.10298 13.0142 8.99998 11.9233 8.99998C10.8325 8.99998 9.94531 8.10298 9.94531 6.99999C9.94531 5.897 10.8325 5 11.9233 5ZM11.9228 11C14.1046 11 15.8788 9.20597 15.8788 6.99998C15.8788 4.79399 14.1046 3 11.9228 3C9.74107 3 7.9668 4.79399 7.9668 6.99998C7.9668 9.20597 9.74107 11 11.9228 11Z"
      />
    </svg>
  );
}

export { ProfileIcon };
